import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";

export default function AppUrlListener() {
    const navigate = useNavigate();

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;

        const sub = CapacitorApp.addListener("appUrlOpen", async ({ url }) => {
            if (!url) return;

            try {
                const parsed = new URL(url);

                if (parsed.protocol !== "stirup:") return;

                const path = `${parsed.host}${parsed.pathname}`;
                // es:
                // stirup://checkout/success?session_id=...
                // stirup://checkout/cancel
                // stirup://checkout/paypal-return?token=...

                await Browser.close().catch(() => { });

                if (path === "checkout/success") {
                    const sessionId = parsed.searchParams.get("session_id");
                    navigate(
                        sessionId
                            ? `/checkout/success?session_id=${encodeURIComponent(sessionId)}`
                            : "/checkout/success",
                        { replace: true }
                    );
                    return;
                }

                if (path === "checkout/cancel") {
                    navigate("/checkout/cancel", { replace: true });
                    return;
                }

                if (path === "checkout/paypal-return") {
                    const token = parsed.searchParams.get("token");
                    const payerId = parsed.searchParams.get("PayerID");

                    const qs = new URLSearchParams();
                    if (token) qs.set("token", token);
                    if (payerId) qs.set("PayerID", payerId);

                    navigate(`/checkout/paypal-return?${qs.toString()}`, {
                        replace: true,
                    });
                }
            } catch (err) {
                console.error("[AppUrlListener] errore parsing URL:", err);
            }
        });

        return () => {
            sub?.remove?.();
        };
    }, [navigate]);

    return null;
}